<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">
        <div class="box citic-box">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-tab-pane
              label="关键词管理"
              name="a"
            >
              <el-card class="box-card">
                <div
                  slot="header"
                  class="clearfix"
                  style="height:30px"
                >
                  <el-row
                    :gutter="20"
                    style="line-height:30px"
                  >
                    <el-col :span="6">
                      <p class="key-title">已录入的维度</p>
                    </el-col>
                    <el-col :span="6">
                      <p class="key-title">维度关键词</p>
                    </el-col>
                  </el-row>
                </div>
                <div
                  v-for="item in formData"
                  :key="item"
                  class="text item"
                >
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <p class="keys">{{item.title}}</p>
                    </el-col>
                    <el-col :span="10">
                      <p class="keys">
                        <el-tag
                          :key="tag.id"
                          v-for="tag in item.keywords"
                          closable
                          @close="handleClose(tag.id)"
                        >
                          {{tag.dimension_keyword_title}}
                        </el-tag>
                      </p>
                    </el-col>
                    <el-col :span="6">
                        <el-input
                        class="input-new-tag"
                        v-model="item.dimension_type_title"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm(item.id,item.dimension_type_title)"
                        @blur="handleInputConfirm(item.id,item.dimension_type_title)"
                        placeholder="录入新的关键词"
                        style="width:200px"
                      >
                      </el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        class="button-new-tag"
                        size="small"
                        @click="addItem(item.id)"
                      >添加</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-tab-pane>
            <el-tab-pane
              label="维度管理"
              name="b"
            >
              <el-card class="box-card">
                <div
                  slot="header"
                  class="clearfix"
                  style="height:30px"
                >
                  <el-row
                    :gutter="20"
                    style="line-height:30px"
                  >
                    <el-col :span="6">
                      <p class="key-title">已录入的维度</p>
                    </el-col>
                    <el-col :span="6">
                      <p class="key-title">所属维度分类</p>
                    </el-col>
                  </el-row>
                </div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-input
                      class="input-new-tag"
                      v-model.trim="inputValue2"
                      ref="saveTagInput"
                      size="small"
                      @keyup.enter.native="handleInputConfirm2"
                      @blur="handleInputConfirm2"
                      placeholder="录入新的维度"
                      style="width:300px"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-button
                      class="button-new-tag"
                      type="primary"
                      @click="addItem2"
                    >添加</el-button>
                  </el-col>
                </el-row>
                <div
                  v-for="(item,index) in dimensionList"
                  :key="item"
                  class="text item"
                >
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <p class="keys">{{item.title}}</p>
                    </el-col>
                    <el-col :span="10">
                      <el-select
                        v-model="item.dimension_type_title"
                        filterable
                        placeholder="请选择所属维度分类"
                      >
                        <el-option
                          v-for="item in selectList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        class="button-new-tag"
                        size="small"
                        @click="addItem3(item.id,index)"
                      >保存</el-button>
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        class="button-new-tag"
                        size="small"
                        type="danger"
                        @click="handleDelete2(item.id)"
                      >删除</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-tab-pane>
            <el-tab-pane
              label="维度分类管理"
              name="c"
            >
              <el-card class="box-card">
                <div
                  slot="header"
                  class="clearfix"
                  style="height:30px"
                >
                  <p class="key-title">已录入的维度</p>
                </div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-input
                      class="input-new-tag"
                      v-model.trim="inputValue3"
                      ref="saveTagInput"
                      size="small"
                      @keyup.enter.native="handleInputConfirm3"
                      @blur="handleInputConfirm3"
                      placeholder="录入新的维度分类"
                      style="width:300px"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-button
                      class="button-new-tag"
                      type="primary"
                      @click="addItem"
                    >添加</el-button>
                  </el-col>
                </el-row>
                <div
                  v-for="item in dimensionType"
                  :key="item"
                  class="text item"
                  style="margin-top: 20px"
                >
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <p class="keys">
                        <el-tag type="success">{{item.title}}</el-tag>
                      </p>
                    </el-col>
                    <el-col :span="6">
                      <el-button
                        @click="handleDelete3(item.id)"
                        type="danger"
                      >删除</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-tab-pane>
          </el-tabs>
        </div>

      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
// import axios from 'axios'
import ThePageHeader from '../../partials/ThePageHeader'
import TheSlideBox from '../../partials/TheSlideBox'
import TheSearchBox from '../../widgets/widgetSearchBox'
import axios from 'axios'

export default {
  name: 'PostHome',
  components: {
    ThePageHeader,
    TheSlideBox,
    TheSearchBox

  },
  data () {
    return {
      inputValue3: '',
      inputValue2: '',
      inputValue: '',
      dimensionType: [],
      dimensionList: {
        title: '',
        type: ''
      },
      formData: [],
      keywords: '',
      tags: [],
      selectList: [],
      inputVisible: false,
      activeName: 'a',
      id: ''
    }
  },
  methods: {
    // 删除tag标签3
    handleDelete3 (id) {
      let url = this.$config.API.analysis.dimensiontype.del
      let data = {
        dimensiontype_id: id
      }
      axios.post(url, data).then(res => {
        this.fetchData('c')
      })
    },
    // 删除tag标签2
    handleDelete2 (id) {
      let url = this.$config.API.analysis.dimension.del
      let data = {
        dimension_id: id
      }
      axios.post(url, data).then(res => {
        this.fetchData('c')
      })
    },
    // 确认输入tag标签
    async handleInputConfirm (id, a) {
      // alert(this)
      console.log('item1', id)
      console.log('item1', a)
      let inputValue = null
      if (id) {
        inputValue = a
      } else {
        inputValue = ''
      }
      if (a === '') return
      let url = await this.$config.API.analysis.keyword.add
      let data = {
        dimension_id: id,
        dimension_keyword_title: a
      }
      axios.post(url, data).then(res => {
        this.formData.map(item => {
          item.keywords.map(a => {
            inputValue = a.unshift(data)
            console.log(a)
          })
        })
      })
      if (inputValue) {
        this.formData.map(item => {
          item.keywords.map(a => {
            inputValue = a.unshift(data)
            console.log(a)
          })
        })
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 确认输入tag标签2
    handleInputConfirm2 () {
      let inputValue = this.inputValue2
      if (inputValue === '') return
      let url = this.$config.API.analysis.dimension.add
      let data = {
        dimension_type: '',
        dimension_title: this.inputValue2
      }
      axios.post(url, data).then(res => {
        console.log('2', res)
      })
      inputValue = {
        title: inputValue
      }
      if (inputValue) {
        this.dimensionList.unshift(inputValue)
      }

      this.inputVisible = false
      this.inputValue2 = ''
    },
    // 确认输入tag标签3
    handleInputConfirm3 () {
      let inputValue = this.inputValue3
      if (inputValue === '') return
      let url = this.$config.API.analysis.dimensiontype.add
      let data = {
        dimensiontype_title: this.inputValue3
      }
      console.log(this.dimensionType)
      axios.post(url, data).then(res => {
        console.log('2', res)
      })
      inputValue = {
        title: inputValue
      }
      if (inputValue) {
        this.dimensionType.unshift(inputValue)
      }

      this.inputVisible = false
      this.inputValue3 = ''
    },
    // 获取列表数据
    select () {
      let url = this.$config.API.analysis.dimensiontype.list
      axios.get(url).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.selectList = res.data.dimensionTypeList
        }
      })
    },
    async fetchData (activeName) {
      let url = null
      if (this.activeName === 'c') {
        url = await this.$config.API.analysis.dimensiontype.list
      } else if (this.activeName === 'b') {
        url = this.$config.API.analysis.dimension.list
      } else {
        url = this.$config.API.analysis.keyword.list
      }
      axios.get(url).then(res => {
        if (res.status === 200) {
          if (this.activeName === 'c') {
            this.dimensionType = res.data.dimensionTypeList
          } else if (this.activeName === 'b') {
            this.dimensionList = res.data.dimensionList
            // this.dimensionList.map(item => {
            //   item.keywords = item.keywords.split(',')
            // })
          } else {
            this.formData = res.data.dimensionList
            this.formData.map(item => {
              item.keywords.map(a => {
                this.keywords = a.dimension_keyword_title
              })
            })
          }
        }
      })
    },
    // 删除tag标签
    handleClose (id) {
      console.log('tag', id)
      let url = this.$config.API.analysis.keyword.del
      let data = {
        dimension_keyword_id: id.toString()
      }
      axios.post(url, data).then(res => {
        console.log(res)
        this.fetchData('a')
      })
    },
    // 显示tag标签
    addItem () {
      this.fetchData('a')
      this.inputValue = ''
    },
    // 显示tag标签
    addItem2 () {
      if (this.inputValue3 === '') return
      let data = {
        title: this.inputValue3
      }
      this.dimensionType.unshift(data)
      this.inputValue3 = ''
    },
    // 显示tag标签
    addItem3 (id, index) {
      let url = this.$config.API.analysis.dimension.edit
      console.log('gg', this.dimensionList[index].title)
      console.log('selectList', this.selectList)
      let data = {
        dimension_type_id: this.selectList[index].id,
        dimension_id: id,
        dimension_title: this.dimensionList[index].title
      }
      axios.post(url, data).then(res => {
        this.fetchData('b')
        this.$message({
          message: '保存成功',
          type: 'success'
        })
      })
    },
    // 切换tab
    handleClick (tab, event) {
      console.log(tab, event)
      this.fetchData(this.activeName)
    }
  },
  mounted () {
    this.fetchData(this.activeName)
    this.select()
  }
}
</script>
<style lang="scss">
.key-title {
  font-size: 16px;
  font-weight: 700;
}
.keys {
  margin-right: 40px;
  padding-bottom: 20px;
  display: inline-block;
}
.el-tag + .el-tag {
  margin-left: 10px;
  // margin-bottom: 10px;
}

.el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// analysis.vue?db745cc8